<template>
	<ChooseConfigurationFieldAsSource
		:serviceId="serviceId"
		v-if="needToChooseFieldToMap"
		:sourceField.sync="fieldUUID"
		@create-source="createSource"
		:credentialsData="credentialsData"
		:credentialsType="credentialsType"
		:configurationType="configurationType"
		:credentialSelectorFields="credentialSelectorFieldsForService"
	/>
	<ConfigurationField
		v-else
		:serviceId="serviceId"
		:narrowLayout="narrowLayout"
		v-bind="configurationFieldProps"
		:credentialsData="credentialsData"
		:credentialsType="credentialsType"
		:configurationType="configurationType"
		:overrideSelectProfile="overrideSelectProfile"
		:credentialSelectorFields="credentialSelectorFieldsForService"
	/>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ConfigurationField from './ConfigurationField.vue';
import { getWorkflowData } from '@/store/modules/workflows/actions';
import { editWorkflow } from '@/store/modules/selectedWorkflow/getters';
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import { getConfiguration } from '@/store/modules/workflowConfigurations/getters';
import WorkflowConfigurationService from '@/utils/workflow-configuration-service';
import { createSourceFieldForEditField } from '@/store/modules/widgetEditor/actions';
import ChooseConfigurationFieldAsSource from './ChooseConfigurationFieldAsSource.vue';
import { CredentialsTypes } from '@ply-io/ply-front-shared-utilities';
export default {
	name: 'ProfileConfigurationSection',
	props: {
		serviceId: { type: Number },
		contextMode: { type: Boolean },
		widgetFieldMode: { type: Boolean },
		narrowLayout: { type: Boolean },
		credentialsData: { type: Object },
		serviceVersionId: { type: String },
		overrideSelectProfile: { type: Function },
		configurationFieldProps: { type: Object },
		credentialsType: { type: String, default: CredentialsTypes.Embedded },
	},
	components: { ConfigurationField, ChooseConfigurationFieldAsSource },
	computed: {
		...mapGetters([getConfiguration.fullPath]),
		...mapGettersShorthand({ editWorkflow }),
		configurationType() {
			return this.credentialsType === CredentialsTypes.ProfileBased ? 'profile' : 'general';
		},
		fieldUUID: {
			get() {
				return this.configurationFieldProps.fieldUUID;
			},
			set(value) {
				if (this.overrideSelectProfile) {
					return this.overrideSelectProfile(null, value);
				} else if (this.contextMode) {
					const credentials_configuration = {
						source_field_uuid: value,
						credentials_type: this.credentialsType,
					};
					this['selectedWorkflow/setContextualDataProfileID']({ credentials_configuration });
					return;
				}
				this['selectedNode/setParamInEditNode']({ key: 'source_field_uuid', value });
			},
		},
		configurationId() {
			return this.configurationFieldProps.configurationId;
		},
		needToChooseFieldToMap() {
			return !this.fieldUUID;
		},
		credentialSelectorFieldsForService() {
			return WorkflowConfigurationService.getConfigurationCredentialsSelectorFieldsForService(
				this.configurationId,
				this.serviceId,
				this.serviceVersionId,
				this[getConfiguration.fullPath]
			).map((field) => ({ title: `${field.metadata.options.title.value}-${field.id}`, id: field.id, nodes: field.source_of_nodes }));
		},
	},
	methods: {
		...mapActionsShorthand({ getWorkflowData }),
		...mapActions(['selectedNode/setParamInEditNode']),
		...mapActions([createSourceFieldForEditField.fullPath]),
		...mapActions(['selectedWorkflow/setContextualDataProfileID']),
		createSourceAction() {
			if (this.contextMode) {
				const credentials_configuration = {
					create_new_source_field: true,
					credentials_type: this.credentialsType,
				};
				return this['selectedWorkflow/setContextualDataProfileID']({ credentials_configuration });
			} else if (this.widgetFieldMode) {
				return this[createSourceFieldForEditField.fullPath]({ configurationId: this.configurationId });
			} else {
				return this['selectedNode/setParamInEditNode']({ key: 'create_new_source_field', value: true });
			}
		},
		async createSource() {
			try {
				await this.createSourceAction();
				await this.getWorkflowData({ forceGet: true, id: this.editWorkflow.id });
			} catch (e) {
				console.error(e);
				this.$toast.error('Error creating source field, please try again later.');
			}
		},
	},
};
</script>

<style lang="scss" scoped></style>
